import { storage, customization } from 'storage';
import { APP_URL } from 'js/common/AppUrl';

import { 
	Viewer,
	TextureLoader,
	ScenePlugin,
	EntityPlugin,
	LightingPlugin,
	GlobalsPlugin,
	BackgroundPlugin,
	SunPlugin,
	MousePlugin,
	SpotLightShadowsPlugin,
	DynamicEnvironmentMapPlugin
} from 'webgl';


export class AubadeViewer extends Viewer{
	constructor(options){


		if(!options.plugins)
			options.plugins = [];

		options.plugins.push(
			ScenePlugin,
			EntityPlugin, 
			LightingPlugin,
			GlobalsPlugin,
			BackgroundPlugin,
			SunPlugin,
			SpotLightShadowsPlugin,
			DynamicEnvironmentMapPlugin,
		);

		super(options);

		this.textureLoader	= new TextureLoader();
	}

	async attach(){
		super.attach();
		await this.setupEnvironment();
	}

	detach(){
		super.detach();
	}

	setupEnvironment(){

		const globalsPlugin = this.plugins.get(GlobalsPlugin);
		globalsPlugin.usePMREM = true;
		globalsPlugin.antialias = false;
		globalsPlugin.outputEncoding = "srgb";
		globalsPlugin.toneMapping = "Custom";
		globalsPlugin.toneMappingExposure = 3.2;
		globalsPlugin.toneMappingWhitepoint = 4;
		globalsPlugin.physicallyCorrectLights = true;

		const lightingPlugin = this.plugins.get(LightingPlugin);
		lightingPlugin.removeLight('ambient');
		lightingPlugin.setLight({
			type:"ambient",
			name:"ambient",
			color:0xffffff,
			intensity:1.5
		});

		// const backgroundPlugin = this.plugins.get(BackgroundPlugin);
		// backgroundPlugin.rotation = 1.6;

		this.update();
	}
}

